import {
  Projectile1000p,
  ProjectileAgentMiniAlien,
  ProjectileAgentNpc,
  ProjectileAgentOfe,
  ProjectileAgentPibi,
  ProjectileAngry,
  ProjectileBalloon,
  ProjectileBalloonFire,
  ProjectileBanana,
  ProjectileBitcoin,
  ProjectileBook,
  ProjectileChori,
  ProjectileChoriIce,
  ProjectileCostillar,
  ProjectileCurrenthing,
  ProjectileDivineShovel,
  ProjectileE,
  ProjectileGnocchi,
  ProjectileGordoMortero,
  ProjectileGreenHeart,
  ProjectileHappy,
  ProjectileHeavenShovel,
  ProjectileJsjs,
  ProjectileKKK,
  ProjectileL,
  ProjectileLittleGoldenChori,
  ProjectileMask,
  ProjectileOrbChoriIce,
  ProjectilePamy,
  ProjectilePancakes,
  ProjectilePinkHeart,
  ProjectileProceda,
  ProjectileShovel,
  ProjectileShovelFire,
  ProjectileShovelGold,
  ProjectileShovelIce,
  ProjectileSnake,
  ProjectileTear,
  ProjectileTile,
  ProjectileV,
  ProjectileWine,
  ProjectileWorkerShovel,
} from './projectiles';

const projectilesMap = {
  'projectile-bitcoin': ProjectileBitcoin,
  'projectile-balloon': ProjectileBalloon,
  'projectile-balloon-fire': ProjectileBalloonFire,
  'projectile-green-heart': ProjectileGreenHeart,
  'projectile-pink-heart': ProjectilePinkHeart,
  'projectile-e': ProjectileE,
  'projectile-kkk': ProjectileKKK,
  'projectile-tile': ProjectileTile,
  'projectile-snake': ProjectileSnake,
  'projectile-gnocchi': ProjectileGnocchi,
  'projectile-wine': ProjectileWine,
  'projectile-banana': ProjectileBanana,
  'projectile-pamy': ProjectilePamy,
  'projectile-v': ProjectileV,
  'projectile-l': ProjectileL,
  'projectile-chori': ProjectileChori,
  'projectile-little-golden-chori': ProjectileLittleGoldenChori,
  'projectile-chori-ice': ProjectileChoriIce,
  'projectile-1000p': Projectile1000p,
  'projectile-shovel': ProjectileShovel,
  'projectile-shovel-gold': ProjectileShovelGold,
  'projectile-shovel-ice': ProjectileShovelIce,
  'projectile-shovel-fire': ProjectileShovelFire,
  'projectile-divine-shovel': ProjectileDivineShovel,
  'projectile-worker-shovel': ProjectileWorkerShovel,
  'projectile-heaven-shovel': ProjectileHeavenShovel,
  'projectile-orb-chori-ice': ProjectileOrbChoriIce,
  'projectile-proceda': ProjectileProceda,
  'projectile-gordo-mortero': ProjectileGordoMortero,
  'projectile-tear': ProjectileTear,
  'projectile-book': ProjectileBook,
  'projectile-agent-mini-alien': ProjectileAgentMiniAlien,
  'projectile-agent-ofe': ProjectileAgentOfe,
  'projectile-agent-pibi': ProjectileAgentPibi,
  'projectile-agent-npc': ProjectileAgentNpc,
  'projectile-mask': ProjectileMask,
  'projectile-angry': ProjectileAngry,
  'projectile-happy': ProjectileHappy,
  'projectile-currenthing': ProjectileCurrenthing,
  'projectile-costillar': ProjectileCostillar,
  'projectile-pancakes': ProjectilePancakes,
  'projectile-jsjs': ProjectileJsjs,
};

export type projectileKey = keyof typeof projectilesMap;

export default projectilesMap;
